import React, { useState, useEffect } from "react";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { makeStyles } from "@material-ui/styles";
import Card from "@material-ui/core/Card";
import CardHeader from "@material-ui/core/CardHeader";
import CardContent from "@material-ui/core/CardContent";
import CardActions from "@material-ui/core/CardActions";
import Typography from "@material-ui/core/Typography";
import Collapse from "@material-ui/core/Collapse";
import Avatar from "@material-ui/core/Avatar";
import IconButton from "@material-ui/core/IconButton";
import { withSnackbar } from "notistack";
import Iframe from "react-iframe";
import Button from "@material-ui/core/Button";

import ExpandMoreIcon from "@material-ui/icons/ExpandMore";

import { hasRole } from "../../../auth";
import SERVER_ADDRESS from "../../../config";
import QRCodeButton from "./QRCodeButton";
const useStyles = makeStyles(theme => ({
  card: {
    width: "100%"
  },
  avatar: {
    backgroundColor: theme.palette.secondary.light
  },
  expand: {
    transform: "rotate(0deg)",
    marginLeft: "auto",
    transition: theme.transitions.create("transform", {
      duration: theme.transitions.duration.shortest
    })
  },
  expandOpen: {
    transform: "rotate(180deg)",
    marginLeft: "auto",
    transition: theme.transitions.create("transform", {
      duration: theme.transitions.duration.shortest
    })
  },
  iframe: {
    margin: "auto"
  }
}));

//主要的Card组件,显示构件详情
function PanoCard(props) {
  const classes = useStyles();
  const { pano, index } = props;
  const { id, name, specification, architecture, pano_url } = pano;
  const [expanded, setExpanded] = useState(false);
  const handleExpandClick = () => {
    setExpanded(!expanded);
  };
  //使用媒介查询,小屏幕宽度时缩小iframe高度
  const matches = useMediaQuery("(min-width:600px)");

  return (
    <Card className={classes.card} raised>
      <CardHeader
        avatar={<Avatar className={classes.avatar}>{index + 1}</Avatar>}
        action={<QRCodeButton qrCodeUrl={pano_url} title="扫码学习" />}
        title={name}
        titleTypographyProps={{ color: "primary", variant: "h6" }}
        subheader={architecture}
      />
      <CardContent>
        <Typography component="p">{specification}</Typography>
      </CardContent>

      <CardActions className={classes.actions} disableActionSpacing>
        {hasRole(["教师"]) && (
          <Button
            color="primary"
            onClick={() => {
              window.open(`${SERVER_ADDRESS}/api/panoramas/${id}/`);
            }}
            variant="text"
          >
            编辑教学资源
          </Button>
        )}
        <IconButton
          onClick={handleExpandClick}
          className={expanded ? classes.expandOpen : classes.expand}
          title="展开案例"
        >
          <ExpandMoreIcon />
        </IconButton>
      </CardActions>

      <Collapse in={expanded} timeout="auto" unmountOnExit>
        <CardContent>
          <Iframe
            url={pano_url}
            width="95%"
            height={matches ? "720px" : "240px"}
            className={classes.iframe}
            allowFullScreen
          />
        </CardContent>
      </Collapse>
    </Card>
  );
}
export default withSnackbar(PanoCard);
